const addToList = ({ commit }, payload) => {
  commit('ADD_TO_LIST', payload);
};

const bulkAddToList = ({ commit }, payload) => {
  commit('BULK_ADD_TO_LIST', payload);
};

const updateInList = ({ commit }, payload) => {
  commit('UPDATE_IN_LIST', payload);
};

const removeFromList = ({ commit }, payload) => {
  commit('REMOVE_FROM_LIST', payload);
};

const clearList = ({ commit }, payload) => {
  commit('CLEAR_LIST', payload);
};

const setChatReadMessages = ({ commit }, payload) => {
  commit('SET_CHAT_READ_MESSAGES', payload);
};

const updateLastReadMessage = ({ commit }, payload) => {
  commit('UPDATE_LAST_READ_MESSAGE', payload);
};

const setUnreadCount = ({ commit }, count) => {
  commit('SET_UNREAD_COUNT', count);
};

export default {
  addToList,
  bulkAddToList,
  updateInList,
  removeFromList,
  clearList,
  setChatReadMessages,
  updateLastReadMessage,
  setUnreadCount,
};
